module.exports = __webpack_public_path__ + "img/guize.ec81a105.png";